export default "__VITE_ASSET__BTI7UK2v__"